import { isDefined } from "@grandvisionhq/utils";
import { getIsAvailableForSubscription } from "./get-is-available-for-subscription.js";
import { getSubscriptionDeliveryIntervals } from "./get-subscription-delivery-intervals.js";
const mapSubscriptionProperties = (serverLineItem, subscriptionIntervalsFallback) => {
  if (serverLineItem.__typename === "LineItemBundle") {
    return {
      isSubscription: false,
      subscriptionDetails: void 0,
      convertToSubscription: void 0
    };
  }
  const isSubscription = serverLineItem.typeDetails?.isSubscription || false;
  const subscriptionDetails = serverLineItem.typeDetails?.subscriptionDetails ? {
    deliveryInterval: serverLineItem.typeDetails.subscriptionDetails.deliveryInterval
  } : void 0;
  const isAvailableForSubscription = getIsAvailableForSubscription(serverLineItem.variant);
  const subscriptionIntervals = getSubscriptionDeliveryIntervals(
    serverLineItem,
    subscriptionIntervalsFallback,
    isAvailableForSubscription,
    isSubscription
  );
  const convertToSubscription = isDefined(subscriptionIntervals) ? { subscriptionIntervals } : void 0;
  return {
    isSubscription,
    subscriptionDetails,
    convertToSubscription
  };
};
export {
  mapSubscriptionProperties
};
//# sourceMappingURL=map-subscription-properties.js.map
